export default __webpack_public_path__ + "static/media/gallery_06.32c42e60.jpg";